export enum Player {
    User = "user",
    AI = "ai",
    NEITHER = "neither"
}